/**
 * Cms YF Internal Menu configuration
 */
export const INTERNAL_MENU_LINKS = [
  {
    url: '/karriere-ratgeber/karriere-im-mittelstand/',
    text: 'Karriere im Mittelstand',
    title: 'Karriere im Mittelstand'
  },
  {
    url: '/karriere-ratgeber/tipps-zu-bewerbung-und-prozess/',
    text: 'Bewerbung',
    title: 'Tipps zu Bewerbung und Prozess'
  },
  {
    url: '/karriere-ratgeber/tipps-rund-ums-gehalt/',
    text: 'Gehalt',
    title: 'Tipps rund ums Gehalt'
  },
  {
    url: '/karriere-ratgeber/jobwiki/',
    text: 'Jobwiki',
    title: 'Berufe verständlich beschrieben'
  },
  {
    url: '/karriere-ratgeber/beschaeftigungsarten/',
    text: 'Beschäftigungsarten',
    title: 'Welche Beschäftigungsarten gibt es, welcher bist Berufstyp Du?'
  },
  {
    url: '/karriere-ratgeber/jobmessen/',
    text: 'Jobmessen',
    title: 'Die wichtigsten Jobmessen in einem Messekalender'
  },
  {
    url: '/recruiting-ratgeber/',
    text: 'Recruiting-Ratgeber',
    title: 'Suche nach Nachwuchskräften und Professionals'
  }
]

export const INTERNAL_MENU_BREAKPOINTS = {
  250: {
    slidesPerView: 1,
    spaceBetween: 0
  },
  500: {
    slidesPerView: 2,
    spaceBetween: 0
  },
  768: {
    slidesPerView: 3,
    spaceBetween: 0
  },
  1200: {
    slidesPerView: 'auto',
    spaceBetween: 50
  }
}
